/**
 * LeadsRpcClient — AtomRpc integration for the public `leads.request` endpoint.
 *
 * The marketing site's "Request your agent" / "Get my quote" forms write a
 * `leads` row through this single unauthenticated RPC (CLA-952). Public
 * endpoint — no authentication required, so it uses the default (null) token
 * getter. NDJSON serialization for consistency with the other RPC clients.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { LeadsPublicRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { ClerkTokenGetter, makeRpcClientLayer } from "./shared.ts";

export class LeadsRpcClient extends AtomRpc.Tag<LeadsRpcClient>()("LeadsRpcClient", {
  group: LeadsPublicRpcs,
  protocol: makeRpcClientLayer(LeadsPublicRpcs).pipe(
    Layer.provide(RpcSerialization.layerNdjson),
    Layer.provide(ClerkTokenGetter.Default), // public RPC — default (null) token
    Layer.provide(FetchHttpClient.layer),
  ),
}) {}
